export default __webpack_public_path__ + "static/media/mechanicsGhostBg.85bdc2d3.png";